import { render, staticRenderFns } from "./BellOff.vue?vue&type=template&id=08d294dc"
import script from "./BellOff.vue?vue&type=script&lang=js"
export * from "./BellOff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports